import { Custom } from "components";
import { useTheme } from "contexts";

type Props = {
  href: string;
  children: React.ReactNode;
};

export const Link = ({ href, children, ...props }: Props) => {
  const { theme } = useTheme();

  return (
    <Custom.Typography
      component="a"
      href={href}
      weight={theme.font.semiBold}
      color={theme.color.accent.color}
      sx={{
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
        "&:active": {
          opacity: 0.8,
        },
      }}
    >
      {children}
    </Custom.Typography>
  );
};
